import RestService from '@/modules/backend/RestService';
import { Model } from '@/modules/backend/Entities/Model';
import { plainToClass } from 'class-transformer';
import { CreateModelData } from '@/modules/backend/Dto/CreateModelData';

/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class Models
 */
export class Models {
  private readonly rest: RestService;

  public constructor(rest: RestService) {
    this.rest = rest;
  }

  public async GetAll(): Promise<Model[]> {
    const items = await this.rest.get<unknown[]>('/api/v1/models');

    return plainToClass(Model, items);
  }

  public async Create(payload: CreateModelData): Promise<Model> {
    const items = await this.rest.post<unknown>('/api/v1/model', payload);
    return plainToClass(Model, items);
  }

  public async Remove(modelId: number): Promise<void> {
    await this.rest.delete(`/api/v1/model/${modelId}`);
  }
}
